export function visibleY(el){
  var rect = el.getBoundingClientRect(), top = rect.top, height = rect.height, 
    elParentNode = el.parentNode;
  // Check if bottom of the element is off the page
  if (rect.bottom < 0) return false
  // Check its within the document viewport
  if (top > document.documentElement.clientHeight) return false
  do {
    rect = elParentNode.getBoundingClientRect();
    if ((top <= rect.bottom) === false) return false;
    // Check if the element is out of view due to a container scrolling
    if ((top + height) <= rect.top) return false;
    elParentNode = elParentNode.parentNode;
  } while (elParentNode !== document.body)
  return true
};

/*
solution found here
https://stackoverflow.com/a/28971955/6935485
*/
export function getVisiblePercentage(el) {
  if (el) {
    var rect = el.getBoundingClientRect(),
    item = {
      el: el,
      x: rect.left,
      y: rect.top,
      w: el.offsetWidth,
      h: el.offsetHeight
    };
    var deduct = 0,
    percentage = 0,
    // x = window.pageXOffset,
    y = window.pageYOffset,
    // w = window.innerWidth,
    h = window.innerHeight;
    if (item.y < y) {
        deduct += (y - item.y);
    }
    if ((item.y + item.h) > (y + h)) {
        deduct += (item.y + item.h) - (y + h);
    }
    if (deduct > item.h) {
        deduct = item.h;
    }
    percentage = Math.round(((item.h - deduct) / item.h) * 100);
    return percentage;
  }
  return 0;
}

// https://stackoverflow.com/a/51121566
export function isElementXPercentInViewport(el, percentVisible) {
  let
    rect = el.getBoundingClientRect(),
    windowHeight = (window.innerHeight || document.documentElement.clientHeight);

  return !(
    Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100)) < percentVisible ||
    Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
  )
};

export function checkVisibility(element) {
  if (element) {
    var position = element.getBoundingClientRect();

    // checking whether fully visible
    if(position.top >= 0 && position.bottom <= window.innerHeight) {
      return true;
    }

    // checking for partial visibility
    if(position.top < window.innerHeight && position.bottom >= 0) {
      return true;
    }

    // let isPartiallyVisible = isElementXPercentInViewport(element, 30);

    // if (isPartiallyVisible) {
    //   return true;
    // }

  }
  
  return false;
}

export function assignActiveElement(sectionList=[]) {
  if (sectionList.length >0 ) {
    for (var i = 0; i < sectionList.length; i++) {
      var sectionListElement = sectionList[i];
      // console.log(sectionListElement.classList + " " + getVisiblePercentage(sectionListElement))
      // if (getVisiblePercentage(sectionListElement) > 0) {
      //   var sectionListElementClasses = sectionListElement.className.split(' ');
      //   if (!(sectionListElementClasses.includes("active"))) {
      //     sectionListElement.className += " active";
      //   }
      // } else {
      //   sectionListElement.classList.remove("active");
      // }
      // console.log(sectionListElement.classList + " " + checkVisibility(sectionListElement));
      if (checkVisibility(sectionListElement)) {
        var sectionListElementClasses = sectionListElement.className.split(' ');
        if (!(sectionListElementClasses.includes("active"))) {
          sectionListElement.className += " active";
        }
      } else if (sectionListElement) {
        sectionListElement.classList.remove("active");
      }
    }
  }
}

export function visibilityObject(element, useNewVisibilityFunc = false, percentVisible = 30) {
  return {
    "element": element,
    "useNewFunc": useNewVisibilityFunc,
    "percentVisible": percentVisible
  }
}

export function checkVisibilityNew(element, useNewPartialVisibleFunc = false, percentVisible = 30) {
  if (element) {
    var position = element.getBoundingClientRect();

    // checking whether fully visible
    if(position.top >= 0 && position.bottom <= window.innerHeight) {
      return true;
    }

    if (!useNewPartialVisibleFunc) {
      // checking for partial visibility
      if(position.top < window.innerHeight && position.bottom >= 0) {
        return true;
      }
    } else {

      // console.log(element.innerHTML);
      let isPartiallyVisible = isElementXPercentInViewport(element, percentVisible);

      if (isPartiallyVisible) {
        return true;
      }
    }

  }
  
  return false;
}

export function assignActiveElementNew(sectionList=[]) {
  if (sectionList.length >0 ) {
    for (var i = 0; i < sectionList.length; i++) {
      var sectionListElement = sectionList[i].element;

      var sectionListElementUseNewFunc = sectionList[i].useNewFunc;

      var sectionListElementPercentVisible = sectionList[i].percentVisible;
      // console.log(sectionListElement.classList + " " + getVisiblePercentage(sectionListElement))
      // if (getVisiblePercentage(sectionListElement) > 0) {
      //   var sectionListElementClasses = sectionListElement.className.split(' ');
      //   if (!(sectionListElementClasses.includes("active"))) {
      //     sectionListElement.className += " active";
      //   }
      // } else {
      //   sectionListElement.classList.remove("active");
      // }
      // console.log(sectionListElement.classList + " " + checkVisibility(sectionListElement));

      var useNewPartialVisibleFunc = sectionListElementUseNewFunc;
      if (checkVisibilityNew(sectionListElement, useNewPartialVisibleFunc, sectionListElementPercentVisible)) {
        var sectionListElementClasses = sectionListElement.className.split(' ');
        if (!(sectionListElementClasses.includes("active"))) {
          sectionListElement.className += " active";
        }
      } else if (sectionListElement) {
        sectionListElement.classList.remove("active");
      }
    }
  }
}

export function changeSlideInClass() {
  var animatedDivs = document.querySelectorAll("div.animated");
  var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  // console.log(animatedDivs);

  if (animatedDivs.length >0 ) {
    // console.log("start of loop");
    for (var i = 0; i < animatedDivs.length; i++) {
      var animatedDivsElement = animatedDivs[i];

      // console.log(animatedDivsElement.classList);
      /**
       * slideInDown
       * slideInUp
       */
      var position = animatedDivsElement.getBoundingClientRect();

      // console.log(position.top + ", " + position.bottom + ", " + windowHeight);

      if (position.bottom < 0) {
        /* meaning bottom is above viewport. sliding down is the only option to show the element */
        if (animatedDivsElement.classList.contains("slideInUp")) {
          animatedDivsElement.classList.remove("slideInUp");
          animatedDivsElement.classList.add("slideInDown");

        }

      }

      // if (position.top > 0 && position.bottom > 0) {
      if (position.top >= windowHeight){
        /* meaning top is within viewport, user will most likely slide up */
        if (animatedDivsElement.classList.contains("slideInDown")) {
          animatedDivsElement.classList.remove("slideInDown");
          animatedDivsElement.classList.add("slideInUp");
        }
      }

    } 
  }
}